import $api from "./openapi";

export default function useGetShopSettings(teamSlug?: string) {
  return $api.useQuery("get", "/api/teams/{team_slug}/shop", {
    params: { path: { team_slug: teamSlug! } },
  });
}

export function useGetShopDisplayUnit(teamSlug?: string) {
  const { data: shop } = useGetShopSettings(teamSlug);
  return shop?.length_display_unit || "in";
}
